import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import TOPICS from './topics.json';
import { brown, orange, useEnglishPage } from './enCommon';

/*
 * 영문 주제별 페이지 (/en/airport-transfer 등, 2026-11-04 사장님: 구글 검색 노출).
 * 글은 topics.json 하나 — prerender/build_prerender.py 도 같은 파일을 읽어 로봇용 HTML 을 만든다(글이 어긋나지 않게).
 * 요금·시간처럼 약속이 되는 말은 넣지 않는다. 주제를 늘리면 서버 WebController 에도 주소를 더한다.
 */
export default function EnTopic({ slug }) {
  const t = TOPICS.find((x) => x.slug === slug);
  useEnglishPage(t.title, t.description);
  const others = TOPICS.filter((x) => x.slug !== slug);

  return (
    <Box component='main' lang='en' sx={{ maxWidth: 900, mx: 'auto', px: { xs: 2, md: 3 }, py: { xs: 3, md: 5 } }}>
      <Typography component='h1' sx={{ fontSize: { xs: 24, md: 34 }, fontWeight: 800, color: brown }}>
        {t.h1}
      </Typography>
      <Typography sx={{ mt: 1.5, color: brown, lineHeight: 1.8, fontSize: { xs: 16, md: 18 } }}>{t.intro}</Typography>

      <Button component={RouterLink} to='/en/center' variant='contained'
        sx={{ mt: 2.5, px: 3, py: 1.1, fontWeight: 800, bgcolor: orange, '&:hover': { bgcolor: '#d98a30' } }}>
        Get a quote by email
      </Button>

      {t.sections.map((s) => (
        <Box component='section' key={s.h2} sx={{ mt: { xs: 4, md: 5 } }}>
          <Typography component='h2' sx={{ fontSize: { xs: 20, md: 24 }, fontWeight: 800, color: brown, borderBottom: `3px solid ${orange}`, pb: 0.5 }}>
            {s.h2}
          </Typography>
          <Box component='ul' sx={{ mt: 1.5, pl: 3, color: brown, lineHeight: 1.9, fontSize: { xs: 15, md: 17 } }}>
            {s.items.map((i) => <li key={i}>{i}</li>)}
          </Box>
        </Box>
      ))}

      <Box component='section' sx={{ mt: { xs: 4, md: 5 } }}>
        <Typography component='h2' sx={{ fontSize: { xs: 20, md: 24 }, fontWeight: 800, color: brown, borderBottom: `3px solid ${orange}`, pb: 0.5 }}>
          Our buses
        </Typography>
        <Typography sx={{ mt: 1.5, color: brown, lineHeight: 1.8 }}>
          45-seat large coach, 28-seat limousine coach and 25-seat mini bus, all with a professional driver.{' '}
          <RouterLink to='/en/bus' style={{ color: orange, fontWeight: 700 }}>See our buses</RouterLink>
        </Typography>
      </Box>

      <Box sx={{ mt: 5, p: { xs: 2.5, md: 3 }, bgcolor: '#FFFDF6', border: `1px solid ${orange}`, borderRadius: 2, textAlign: 'center' }}>
        <Typography sx={{ fontWeight: 800, color: brown, fontSize: { xs: 17, md: 20 } }}>Tell us about your trip</Typography>
        <Typography sx={{ mt: 0.5, color: brown }}>Send your dates, places and group size — we reply by email in English.</Typography>
        <Button component={RouterLink} to='/en/center' variant='contained'
          sx={{ mt: 2, px: 4, py: 1.1, fontWeight: 800, bgcolor: orange, '&:hover': { bgcolor: '#d98a30' } }}>
          Request a quote
        </Button>
      </Box>

      <Box component='nav' sx={{ mt: 5 }}>
        <Typography component='h2' sx={{ fontSize: 18, fontWeight: 800, color: brown }}>More ways to travel with us</Typography>
        <Box component='ul' sx={{ mt: 1, pl: 3, lineHeight: 2 }}>
          {others.map((o) => (
            <li key={o.slug}>
              <RouterLink to={`/en/${o.slug}`} style={{ color: orange, fontWeight: 700 }}>{o.card}</RouterLink>
              <Box component='span' sx={{ color: brown }}> — {o.cardText}</Box>
            </li>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
